import { render, staticRenderFns } from "./add-member-dialog.vue?vue&type=template&id=4d732c52&scoped=true"
import script from "./add-member-dialog.vue?vue&type=script&lang=js"
export * from "./add-member-dialog.vue?vue&type=script&lang=js"
import style0 from "./add-member-dialog.vue?vue&type=style&index=0&id=4d732c52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d732c52",
  null
  
)

export default component.exports